import { useMutation, useQueryClient } from 'react-query';
import { successToast } from 'lib/components/toasts/success';
import { EXPRESS_API } from 'configs/api/expressApi';
import { videoKeys } from './videosKeys';
import { useToastError } from 'lib/hooks';
import { useTranslation } from 'react-i18next';

type Props = {
  videoId: string;
  copy: boolean;
  videoFolder: string;
  fromCompany?: boolean;
  successMessage?: string;
  itemId?: number;
};
const moveCopyVideo = async (data: Props) => {
  const { videoId, copy, videoFolder, fromCompany } = data;
  const response = await EXPRESS_API.put(`/videos/${videoId}/move`, {
    copy,
    videoFolder,
    fromCompany,
  });
  return response.data;
};
export const useVideoMoveCopy = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { showError } = useToastError();
  return useMutation(moveCopyVideo, {
    onSuccess: (_, variables: Props) => {
      successToast({
        title:
          variables?.successMessage || t('Videos copied/moved successfully.'),
      });
      queryClient.invalidateQueries(videoKeys.inventoryItem(variables.itemId));
    },
    onError: error => {
      showError(
        error || t('An error occurred while moving/copying the videos.')
      );
    },
  });
};
